import { checkStateHasReportData, useCMAStore } from 'features/CMA/infra/react/CMAState'
import { PartialRange } from 'features/valueObjects/Range'
import { BathsFilterCardDumb } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/BathsFilterCard/BathsFilterCard.dumb'
import { BathsFilterCardDumbProps as Props } from 'presentation/screens/CompsScreen/components/CompsFilterPanel/components/BathsFilterCard/BathsFilterCard.dumb.props'
import { shallow } from 'zustand/shallow'

export const BathsFilterCard = () => {
  const isReady = useCMAStore(state =>
    checkStateHasReportData(state.local.report),
  )

  const {
    subjectValue,
    filterValue,
  } = useCMAStore(state => {
    if (!checkStateHasReportData(state.local.report)) {
      return {
        subjectValue: null,
        filterValue: null,
      }
    }

    return {
      subjectValue: state.local.report.data.salesListInfo.subject?.bathroomsCountInfo?.full ?? null,
      filterValue: state.local.report.data.filters.bathroomsCount,
    }
  }, shallow)
  const filterComps = useCMAStore(state => state.actions.filterComps.execute)

  const handleOnValueChange: Props['onChange'] = filter => {
    void filterComps({
      bathroomsCount: filter,
    })
  }

  if (!isReady) return null

  return (
    <BathsFilterCardDumb
      value={filterValue || {
        range: PartialRange.EMPTY,
        shouldMatchSubjectProperty: false,
      }}
      onChange={handleOnValueChange}
      subjectValue={subjectValue}
    />
  )
}
